import { createStructuredSelector } from 'reselect';
import { connect } from 'react-redux';
import { disabledTemplateButtonSelector } from '../../../../../../../../redux/product/product.details.selectors';
import { imprintAreaTemplateSelector, isLimitedEditionSelector, uploadDesignProductDetailsBlockHeaderSelector, imprintAreaTemplateExistsSelector, currentTemplateFileNameNameSelector } from '../../../../../../../../redux/product/product.selectors';
import { UploadLogos as UploadLogosComponent } from './upload-logos';
const uploadLogosSelector = createStructuredSelector({
  isLimitedEdition: isLimitedEditionSelector,
  uploadDesignProductDetailsBlockHeader: uploadDesignProductDetailsBlockHeaderSelector,
  disabledTemplateButtonMessage: disabledTemplateButtonSelector,
  imprintAreaTemplate: imprintAreaTemplateSelector,
  imprintAreaTemplateExists: imprintAreaTemplateExistsSelector,
  templateFileName: currentTemplateFileNameNameSelector
});
export const UploadLogos = connect(uploadLogosSelector)(UploadLogosComponent);